import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.title',
        defaultMessage: 'Protecting your valuables'
    },
    multipointLockingDevice: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.multipointLockingDevice',
        defaultMessage: 'Multipoint Locking Device'
    },
    bs3621Locks: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.bs3621Locks',
        defaultMessage: 'Bs3621Locks'
    },
    twoSecurityLocksOfAnyType: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.twoSecurityLocksOfAnyType',
        defaultMessage: 'Two Security Locks Of Any Type'
    },
    other: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.other',
        defaultMessage: 'Other'
    },
    audibleAnnualMaintenance: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.audibleAnnualMaintenance',
        defaultMessage: 'Audible annual maintenance'
    },
    audibleNoAnnualMaintenance: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.audibleNoAnnualMaintenance',
        defaultMessage: 'Audible no annual maintenance'
    },
    monitoredNoAnnualMaintenance: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.monitoredNoAnnualMaintenance',
        defaultMessage: 'Monitored no annual maintenance'
    },
    monitoredAnnualMaintenance: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.monitoredAnnualMaintenance',
        defaultMessage: 'Monitored annual maintenance'
    },
    none: {
        id: 'quoteandbind.ngh.views.valuables.protectingYourValuables.none',
        defaultMessage: 'None'
    }
});
